import { useRouteMatch as useRouterRouteMatch } from 'react-router-dom';

import { RouteParams } from 'src/types/routes.types';

export const useRouteMatch = (
  ...params: Parameters<typeof useRouterRouteMatch>
) => useRouterRouteMatch<RouteParams>(...params);
